import React from 'react';
import { Toaster } from 'react-hot-toast';

const CustomToaster = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        // Base styles
        style: {
          background: 'linear-gradient(135deg, #ffffff, #f2f6fb)',
          color: '#222',
          fontFamily: '"Inter", system-ui, sans-serif',
          borderRadius: '12px',
          padding: '14px 18px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(10, 102, 194, 0.15)',
        },
        // Success toast
        success: {
          iconTheme: {
            primary: '#0a66c2',
            secondary: '#fff',
          },
          style: {
            background: 'linear-gradient(135deg, #e9f4ff, #f8fbff)',
            borderLeft: '4px solid #0a66c2',
          },
        },
        // Error toast
        error: {
          iconTheme: {
            primary: '#e63946',
            secondary: '#fff',
          },
          style: {
            background: 'linear-gradient(135deg, #fff0f0, #ffeaea)',
            borderLeft: '4px solid #e63946',
          },
        },
        // Loading or default
        loading: {
          style: {
            background: 'linear-gradient(135deg, #f7f9fc, #edf2f7)',
            borderLeft: '4px solid #0078d4',
          },
        },
      }}
    />
  );
};

export default CustomToaster;
